import { useParams } from 'react-router-dom';
import { getRandomArray } from '../../../utils/getRandomArray/getRandomArray';
import color from '../../../data/color/color.json';
import styles from '../Museum.module.scss';

export const Public = ({ upPage }) => {
  const { lang } = useParams();
  const { toptitle, title, text, items } = upPage.acf.public;
  const upRanColArr = getRandomArray(color.length, items.length);

  return (
    <section className={styles.public}>
      <div className="container">
        <div className={styles.public_body}>
          <h3 className={`${styles.public_toptitle} global-subtitle`}>{toptitle[lang]}</h3>
          <h2 className={`${styles.public_title} global-title`}>{title[lang]}</h2>
          <p className={`${styles.public_text} global-text`}>{text[lang]}</p>
          <div className={styles.public_row}>
            {items.map((el, idx) => {
              const { toptitle, title, text } = el;
              return (
                <div key={idx} className={styles.public_column}>
                  <div className={styles.public_column_body}>
                    <div className={styles.public_column_wallpaper} style={{ background: color[upRanColArr[idx]] }}></div>
                    <p className={styles.public_column_toptitle} style={{ color: '#000' }}>
                      {toptitle[lang]}
                    </p>
                    <h4 className={styles.public_column_title} style={{ color: '#000' }}>
                      {title[lang]}
                    </h4>
                    <p className={`${styles.public_column_text} global-text`} style={{ color: '#000' }}>
                      {text[lang]}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
